import { useState, useEffect,useContext } from "react"
import styles from "./Entering.module.css"
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { productData } from "../Constant/ConstantRegister";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";

type kind = {
    leftright: string;
    size: string;
    color: string;
    quantity: number;
    office: string;
}

export default function ConstantRegister() {
    const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
    const [selectedManufacture, setSelectedManufacture] = useState<string>("");
    const [products, setProducts] = useState<productData[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [productData, setProductData] = useState<productData | null>(null);
    const [kinds, setKinds] = useState<kind[]>([]);
    const { auth,setAuth } = useContext(AuthContext) as AuthContextType;
    const [selectedOffice, setSelectedOffice] = useState<string>(auth.office ? auth.office : "");

    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                    const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                })
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                   setAuth({ username: null, isAuthenticated: false, office: undefined , authority:"user"});
                   return navigate("/login");
                }
                        const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
                } catch (error) {
                console.error(error);
            }
        }
        checkAuth();

        const fetchSelectInit = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            return
            }
            const Manufactures = data.manufacture.map((item: Object) => Object.values(item))
            setSelectManufacture(Manufactures);
        }
        fetchSelectInit();
    }, [navigate, setAuth])

    useEffect(() => {
        const fetchSelectProducts = async () => {
            const response = await fetch(`${baseUrl}/getproducts`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "manufacture": selectedManufacture
                })
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            setProducts(data);
        }

        fetchSelectProducts();
    }, [selectedManufacture, navigate,setAuth]);

    const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOffice(e.target.value);
    }

    const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedManufacture(e.target.value);
    }

    const handleProducts = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedProduct(e.target.value);
    }

    const quantityRender = async () => {
        const selectedProductData = products.find(item=>item.productname===selectedProduct)
        const product_id = selectedProductData?.product_id;
        const response = await fetch(`${baseUrl}/productdata`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "product_id": product_id
            })
        })
        const data = await response.json();
        if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
if (data === undefined) {
            alert("製品データが確認できません。")
            return;
        }
            setProductData(data);


        let Kinds: kind[] = [];

        for (let i = 0; data.color.length > i; i++) {
            for (let j = 0; data.leftright.length > j; j++) {
                for (let k = 0; data.size.length > k; k++) {
                    let Kind: kind = {
                        leftright: data.leftright[j],
                        size: data.size[k],
                        color: data.color[i],
                        quantity: 0,
                        office: selectedOffice
                    };
                    Kinds.push(Kind);
                }
            }
        }
        setKinds(Kinds);
    }

    const increment = (index: number) => {
        const newKind = { ...kinds[index], quantity: kinds[index].quantity + 1 };
        const newKinds = [...kinds];
        newKinds.splice(index, 1, newKind);
        setKinds(newKinds);
    }
    const decrement = (index: number) => {
        const newKind = { ...kinds[index], quantity: kinds[index].quantity - 1 };
        const newKinds = [...kinds];
        newKinds.splice(index, 1, newKind);
        setKinds(newKinds);
    }

    const quantityPush = async () => {
        const pushlist = [...kinds];
        const newkinds = pushlist.filter(item => item.quantity > 0);
        const response = await fetch(`${baseUrl}/quantitypush`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "product_id": productData?.product_id,
                "kinds": newkinds,
            })
        })
        const data = await response.json();
        if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        alert(data.message);
        navigate("/Control");
    }

    const resetOffice = () => {
        setSelectedOffice("");
        setSelectedManufacture("");
        setSelectedProduct("");
        setProductData(null);
        setKinds([]);
    }

    return (
        <div className={styles.div}>
            <h2 className={styles.h2}>製品入庫</h2>
            {(!selectedOffice) ? (<div><p>入庫する支店を選択してください。</p>
                <select value={selectedOffice} onChange={handleOffice} className={styles.select}>
                    <option value="" hidden>支店</option>
                    <option value="函館店">函館店</option>
                    <option value="札幌店">札幌店</option>
                    <option value="釧路店">釧路店</option>
                    <option value="室蘭店">室蘭店</option>
                </select>
            </div>) : <div className={styles.reset}><h3 className={styles.h3}>{selectedOffice}</h3><Button onClick={resetOffice} variant="contained" sx={{ margin: 5, "@media screen and (max-width:959px)": { margin: 3 } }}>支店を変更する</Button></div>}
            {(selectedOffice) ? (
                <div className={styles.div2}>
                    <div className={styles.selectwrapper}>
                        <label htmlFor="manufacture">メーカー
                            <select value={selectedManufacture} onChange={handleManufacture} className={styles.select} id="manufacture">
                                <option value="">未設定</option>
                                {selectManufacture.map(item => (<option key={item} value={item}>{item}</option>))}
                            </select></label>
                        <label htmlFor="product">製品
                            <select value={selectedProduct} onChange={handleProducts} className={styles.select} id="product">
                                <option value="">未設定</option>
                                {products.map((item, index) => (<option key={index} value={item.productname}>{item.productname}</option>))}
                            </select></label>
                        <Button onClick={quantityRender} variant="contained" >選択した製品のリストを表示する</Button>
                    </div>
                    {productData && (<div className={styles.div}>
                        <Button onClick={quantityPush} variant="contained" style={{ width: 150, height: 40, margin: 10 }}>入庫する</Button>
                        <p>現在の在庫数に追加する数を設定してください。</p>
                        <div className={styles.scroll}>
                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th className={styles.th}>製品名</th>
                                        <th className={styles.th}>色</th>
                                        <th className={styles.th}>左右</th>
                                        <th className={styles.th}>サイズ</th>
                                        <th className={styles.th}>入庫数</th>
                                        <th className={styles.th}>入庫数の設定</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {kinds.map((item, index) => (
                                        <tr key={index} className={styles.tr}>
                                            <td className={styles.td}>{productData.productname}</td>
                                            <td className={styles.td}>{item.color}</td>
                                            <td className={styles.td}>{item.leftright}</td>
                                            <td className={styles.td}>{item.size}</td>
                                            <td className={styles.td2}>{item.quantity}</td>
                                            <td className={styles.td3}><Button key={`increment${index}`} onClick={() => increment(index)} variant="contained" >+1</Button><Button key={`decrement${index}`} onClick={() => decrement(index)} disabled={item.quantity < 1} variant="contained">-1</Button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>)}
                </div>) : null}
        </div>
    )
}